"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preset = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dateFns = require("date-fns");
var _Button = require("../../../../elements/button/Button");
var _presetModule = _interopRequireDefault(require("./preset.module.scss"));
var _useTranslation2 = require("../../../../hooks/useTranslation/useTranslation");
var Preset = function Preset(_ref) {
  var date = _ref.date,
    onChange = _ref.onChange,
    onFocusChange = _ref.onFocusChange,
    excludeDates = _ref.excludeDates;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var isSelected = date && (0, _dateFns.isSameDay)(date, new Date());
  var isDisabled = excludeDates ? excludeDates(new Date()) : false;
  var onClick = (0, _react.useCallback)(function () {
    onChange(new Date());
    if (onFocusChange) {
      onFocusChange(false);
    }
  }, [onChange, onFocusChange]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _presetModule.default['preset']
  }, /*#__PURE__*/_react.default.createElement(_Button.NeutralButton, {
    small: true,
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, _presetModule.default['preset__button--active'], isSelected)),
    onClick: onClick,
    tabIndex: -1,
    disabled: isDisabled
  }, t('date.presets.today')));
};
exports.Preset = Preset;